/**
 * *Done* on a stop — the stop page's, the stop card's, the calendar menu's
 * *Mark done*. A repeating meeting is done **one occurrence at a time** (the
 * lead's note on Aaron's Oct 27 answer 12, migration 0152): *Done* at
 * Tuesday's huddle used to set the meeting's own `done_at`, which drew every
 * Tuesday done. Anything else — a one-off meeting, a site visit, a task — is
 * done as it always was.
 */
import { activityRequest } from '../api.js'

/** What is being ticked: an item or a card, and the occurrence it is when it is one. */
export interface DoneTarget {
  id: string
  kind: string
  /** Its own day in the series — set only on an occurrence of a repeat. */
  occurrence?: string | null
}

/** Marks it done (or not): one occurrence of a repeating meeting by itself, anything else whole. */
export function markDone(target: DoneTarget, done = true): Promise<unknown> {
  if (target.kind === 'meeting' && target.occurrence) {
    return activityRequest(`/activity/occurrences/${target.id}/done`, {
      method: 'POST', body: { occurrence: target.occurrence, done },
    })
  }
  return activityRequest(`/activities/${target.id}/done`, { method: 'POST', body: { done } })
}

/** The series' own card of a repeating meeting has no *Done*: it is done one occurrence at a time. */
export function offersDone(card: { kind: string; recurrence?: unknown; occurrence?: string | null }): boolean {
  return !(card.kind === 'meeting' && card.recurrence && !card.occurrence)
}
